import React, { useEffect, useState, useMemo } from 'react';
import PerformanceUtils from 'services/PerformanceUtils';
import AppointmentNoteBadge from 'components/HealthRecords/AppointmentNotes/AppointmentNoteBadge';
import ListWithDetails from 'components/Common/ListWithDetails';
import AppointmentNoteDetails from 'components/HealthRecords/AppointmentNotes/AppointmentNoteDetails';
import CalendarUtils from 'services/CalendarUtils';
import DefaultButton from 'components/Utils/NewDefaultButton';
import CPPUtils from 'services/CPPUtils';
import { ACTIVE_TAB } from 'components/Patient/CPP/CPPTimeline/CPPTimelineAppointmentNoteDraft';
import RouteUtils from 'services/RouteUtils';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import { setFormValues } from 'hooks/useReduxForm';

const NoteDraftHistory = ({ patient, onClose, bubble }) => {
  const nav = useNavStack(Stacks.Master);
  const dispatch = useAppDispatch();
  const [drafts, setDrafts] = useState([]);

  const patientId = patient.id;
  const formName = CPPUtils.getFormName(ACTIVE_TAB, (bubble || {}).appointment_id || patientId);

  useEffect(() => {
    dispatch(api.HealthRecords.getPatientNotesDraft({ patientId, backups: true })).then(
      (result) => {
        setDrafts(result || []);
      },
    );
  }, [dispatch, patientId]);

  function changeTab() {
    let route = RouteUtils.getCPPRoute(patientId, ACTIVE_TAB);
    nav.push(route);
  }

  function editDraft(draft) {
    let newDraft = PerformanceUtils.clone(draft);
    newDraft.id = undefined;
    newDraft.note.id = undefined;
    let data = CPPUtils.getAppointmentNoteEditElement(newDraft.note, newDraft.id);
    dispatch(setFormValues({ formName, values: { ...data } }));
    changeTab();
    onClose();
  }

  const items = useMemo(() => {
    return PerformanceUtils.sortBy(drafts, ['date']);
  }, [drafts]);

  return (
    <div className="list full-height flex flex-row">
      <ListWithDetails
        items={items}
        renderBadge={(item) => (
          <AppointmentNoteBadge
            item={item.note}
            firstLine={item.note.value.value}
            secondLine={CalendarUtils.format(item.date, 'Do MMM YYYY h:mm:ss A')}
          />
        )}
        renderDetails={(item) => (
          <div className="flex flex-col grow full-height">
            <AppointmentNoteDetails
              key={item.note.id}
              patient={patient}
              note={item.note}
              inputDisabled={true}
            />
            <div className="buttons-wrapper padded-box">
              <DefaultButton
                style={{ width: '250px' }}
                className="blue"
                icon="pencil"
                onClick={() => editDraft(item)}
                name="Edit This Version"
              />
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default NoteDraftHistory;
